import * as React from 'react';
import {Card, CardContent, Grid, TextField, InputLabel, Checkbox, Box, Button} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { NflSeason } from '../../../sdk/model';
import MoneyFormat from '../../util/MoneyFormat';
import { nflSeasonApi } from '../../../adapters/APIExporter';

interface SeasonConfigProps {
  season: NflSeason,
  updateSeason: Function,
  deleteSeason: Function
}

function SeasonConfig(props: SeasonConfigProps) {
  const [mutableSeason, setMutableSeason] = React.useState(props.season);
  const [editing, setEditing] = React.useState(!props.season.id);
  
  function handleChange(event) {
    const {name, value} = event.target;
    const newMutableSeason = {...mutableSeason};
    if (name === 'salaryCapEstimated') {
      newMutableSeason.salaryCapEstimated = !newMutableSeason.salaryCapEstimated;
    } else {
      newMutableSeason[name] = value;
    }
    setMutableSeason(newMutableSeason);
  }
  
  function cancelEdit() {
    if (!props.season.id) {
      props.deleteSeason();
    } else {
      setMutableSeason({...props.season});
      setEditing(false);
    }
  }
  
  function save() {
    nflSeasonApi.saveNflSeason(mutableSeason!).then((newSeason) => {
      props.updateSeason(newSeason);
      setEditing(false);
    })
  }
  
  const saveDisabled = !mutableSeason.seasonYear || !mutableSeason.salaryCap;
  
  return <Card variant="outlined" sx={{mb: 1, paddingTop: '15px'}}>
    <CardContent sx={{paddingTop: 0}}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField name="seasonYear" label="Season Year: " value={mutableSeason.seasonYear} type="number" onChange={handleChange} disabled={!editing} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField name="salaryCap" label="Salary Cap: " value={mutableSeason.salaryCap}
                      InputProps={{inputComponent: MoneyFormat as any}} onChange={handleChange} disabled={!editing}/>
        </Grid>
        <Grid item xs={12} md={4}>
          <InputLabel id="salaryCapEstimatedLabel">Salary Cap Estimated?</InputLabel>
          <Checkbox name="salaryCapEstimated" checked={mutableSeason.salaryCapEstimated} labelId="salaryCapEstimatedLabel" onChange={handleChange} disabled={!editing}/>
        </Grid>
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Final Date of Rookie Draft: "
            value={mutableSeason.finalDateOfRookieDraft}
            onChange={date => handleChange({ target: { value: date, name: 'finalDateOfRookieDraft' } })}
            disabled={!editing}
            renderInput={(params) => <TextField {...params} />}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Season Start Date: "
            value={mutableSeason.seasonStartDate}
            onChange={date => handleChange({ target: { value: date, name: 'seasonStartDate' } })}
            disabled={!editing}
            renderInput={(params) => <TextField {...params} />}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Final Date for League Start: "
            value={mutableSeason.finalDateForLeagueStart}
            onChange={date => handleChange({ target: { value: date, name: 'finalDateForLeagueStart' } })}
            disabled={!editing}
            renderInput={(params) => <TextField {...params} />}
          />
        </Grid>
      </Grid>
      <br/><br/>
      {editing ?
        <Box>
          <Button className='capsized-button' onClick={cancelEdit}>Cancel</Button>
          <Button className='capsized-button' onClick={save} disabled={saveDisabled}>Save</Button>
        </Box> :
        <Button className='capsized-button' onClick={() => setEditing(true)}>Edit</Button>
      }
    </CardContent>
  </Card>
}

export default SeasonConfig;
